import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Button, Flex } from "@chakra-ui/react";
import { useFormikContext } from "formik";
import { trackActivate as track } from "~/OnboardingApp/events";

export const ActivateCta: FC = () => {
  const { t } = useTranslation();
  const { isSubmitting, isValid } = useFormikContext();

  return (
    <Flex justify="center" w="full">
      <Button
        isDisabled={!isValid || isSubmitting}
        onClick={track.submitActivationCode}
        size="th-md"
        type="submit"
        variant="th-primary"
        w="fit-content"
      >
        {t("onboarding.activate.card.cta")}
      </Button>
    </Flex>
  );
};
